import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { BoxContainer } from '@/components';
import ChartInner from './components/ChartInner/ChartInner';
import styles from './index.module.scss';

export type SwitcherChartProps =
  SliceComponentProps<Content.SwitcherChartSlice>;

const SwitcherChart: FC<SwitcherChartProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <BoxContainer styles={styles.wrapper}>
        <ChartInner slice={slice} />
      </BoxContainer>
    </section>
  );
};

export default SwitcherChart;
